<script lang="ts">
    import {Component} from 'vue-facing-decorator'
    import {ProductBookingFieldsMixin} from '@/components/booking/mixins/ProductBookingFieldsMixin.vue'

    @Component
    export class TransferBookingFieldsMixin extends ProductBookingFieldsMixin {
        filterPrepareBookRequest(prepareBookRequest) {
            if (this.isProductFieldDisabled('PICK_UP_TIME')) delete prepareBookRequest.time
            if (this.isProductFieldDisabled('PICK_UP_SIGN')) delete prepareBookRequest.pickupSign
            if (this.isProductFieldDisabled('POINT_FLIGHT_TIME')) {
                if (prepareBookRequest.arrival.type === 'airport') delete prepareBookRequest.arrival?.dateTime
                if (prepareBookRequest.departure.type === 'airport') delete prepareBookRequest.departure?.dateTime
            }
            if (this.isProductFieldDisabled('POINT_FLIGHT_NUMBER')) {
                delete prepareBookRequest.arrival?.flightNumber
                delete prepareBookRequest.departure?.flightNumber
            }
            if (this.isProductFieldDisabled('POINT_AIRPORT')) {
                delete prepareBookRequest.arrival?.otherAirportCode
                delete prepareBookRequest.departure?.otherAirportCode
            }
            if (this.isProductFieldDisabled('POINT_TERMINAL')) {
                delete prepareBookRequest.arrival?.terminal
                delete prepareBookRequest.departure?.terminal
            }
            if (this.isProductFieldDisabled('POINT_HOTEL_NAME')) {
                delete prepareBookRequest.arrival?.hotelName
                delete prepareBookRequest.arrival?.hotelCode
                delete prepareBookRequest.departure?.hotelName
                delete prepareBookRequest.departure?.hotelCode
            }
            if (this.isProductFieldDisabled('POINT_ADDRESS')) {
                delete prepareBookRequest.arrival?.address
                delete prepareBookRequest.departure?.address
            }
            if (this.isProductFieldDisabled('POINT_POSTAL_CODE')) {
                delete prepareBookRequest.arrival?.postalCode
                delete prepareBookRequest.departure?.postalCode
            }
            if (this.isProductFieldDisabled('POINT_SHIP_CITY')) {
                if (prepareBookRequest.arrival.type === 'port') delete prepareBookRequest.arrival?.cityId
                if (prepareBookRequest.departure.type === 'port') delete prepareBookRequest.departure?.cityId
            }
            if (this.isProductFieldDisabled('POINT_SHIP_NUMBER')) {
                delete prepareBookRequest.arrival?.shipNumber
                delete prepareBookRequest.departure?.shipNumber
            }
            if (this.isProductFieldDisabled('POINT_SHIP_TIME')) {
                if (prepareBookRequest.arrival.type === 'port') delete prepareBookRequest.arrival?.dateTime
                if (prepareBookRequest.departure.type === 'port') delete prepareBookRequest.departure?.dateTime
            }
            if (this.isProductFieldDisabled('POINT_TRAIN_CITY')) {
                if (prepareBookRequest.arrival.type === 'train') delete prepareBookRequest.arrival?.cityId
                if (prepareBookRequest.departure.type === 'train') delete prepareBookRequest.departure?.cityId
            }
            if (this.isProductFieldDisabled('POINT_TRAIN_NUMBER')) {
                delete prepareBookRequest.arrival?.trainNumber
                delete prepareBookRequest.departure?.trainNumber
            }
            if (this.isProductFieldDisabled('POINT_TRAIN_TIME')) {
                if (prepareBookRequest.arrival.type === 'train') delete prepareBookRequest.arrival?.dateTime
                if (prepareBookRequest.departure.type === 'train') delete prepareBookRequest.departure?.dateTime
            }
            if (this.isProductFieldDisabled('POINT_MANUAL_CITY')) {
                delete prepareBookRequest.arrival?.name
                delete prepareBookRequest.departure?.name
            }
            if (this.isProductFieldDisabled('POINT_MANUAL_LATITUDE')) {
                delete prepareBookRequest.arrival?.latitude
                delete prepareBookRequest.departure?.latitude
            }
            if (this.isProductFieldDisabled('POINT_MANUAL_LONGITUDE')) {
                delete prepareBookRequest.arrival?.longitude
                delete prepareBookRequest.departure?.longitude
            }
            return prepareBookRequest
        }
    }

    export default TransferBookingFieldsMixin
</script>
